import React from 'react';
import { MdPermContactCalendar } from 'react-icons/md';
import Fuse from 'fuse.js';
import _ from 'lodash';
import SearchItem from './SearchItem';
import { useSelector, useDispatch } from 'react-redux';
import { setPlaceholderLoading } from '../../../../../../../redux/actions/cardUIV2';

const EmailTypeSearch = ({
	placeholderText: text,
	setPlaceholderSearchItems,
	searchItems,
	selectedIndex,
}) => {
	const [allItems, setAllItems] = React.useState([]);
	const dispatch = useDispatch();
	const contacts = useSelector(
		/**
		 * @param {{cardUIV2: import('../../../../../../redux/reducers/cardUIV2').default}} state
		 */
		(state) => state.profiles.contacts
	);
	React.useEffect(() => {
		var contactsArray = [];
		for (let key in contacts) {
			contactsArray = _.concat(contactsArray, contacts[key]);
		}

		var emailArray = [];

		contactsArray.forEach((contact) => {
			contact.emailAddresses.forEach((email) => {
				emailArray.push({ name: contact.displayName, email: email });
			});
		});
		setAllItems(emailArray);
	}, [contacts]);

	React.useEffect(() => {
		var contactsArray = [];
		for (let key in contacts) {
			contactsArray = _.concat(contactsArray, contacts[key]);
		}
		if (contactsArray.length === 0) {
			setFilteredItems([
				{
					item: {
						name: 'No contacts found',
						email: 'Type email address manually or import contacts for easy access',
					},
				},
			]);
		} else {
			setFilteredItems([
				{
					item: {
						name: 'Contacts found in directory',
						email: `Search through and select any to continue.`,
					},
				},
			]);
		}
	}, [allItems]);

	const options = {
		// isCaseSensitive: false,
		includeScore: true,
		// shouldSort: true,
		// includeMatches: false,
		// findAllMatches: false,
		// minMatchCharLength: 1,
		// location: 0,
		threshold: 0.3, // the less the more accurate the match
		distance: 10,
		// useExtendedSearch: false,
		// ignoreLocation: false,
		// ignoreFieldNorm: false,
		keys: ['name', 'email'],
	};

	const fuse = new Fuse(allItems, options);

	const [filteredItems, setFilteredItems] = React.useState([]);

	/**
	 * This value will get selected by the placeholder, in this case it is email
	 * @param {} array
	 */
	const selectFunction = (itemsArray) => {
		return itemsArray.map((thing) => {
			return { show: thing.item.email, submit: thing.item.email };
		});
	};

	var doneTypingInterval = 10; //time in ms, 5 second for example
	const typingTimer = React.useRef(null);
	const maxResults = 5;
	const onTextChange = (searchText) => {
		var contactsArray = [];
		for (let key in contacts) {
			contactsArray = _.concat(contactsArray, contacts[key]);
		}
		if (contactsArray.length === 0) {
			setFilteredItems([
				{
					item: {
						name: 'No contacts found',
						email: 'Type email address manually or import contacts for easy access',
					},
				},
			]);
		} else {
			if (
				searchText &&
				_.findIndex(searchItems, function (o) {
					return o.show === searchText;
				}) === -1
			) {
				dispatch(setPlaceholderLoading(true));
				var results = fuse.search(searchText).slice(0, maxResults);
				if (results.length > 0) {
					setFilteredItems(results);
					setPlaceholderSearchItems(selectFunction(results));
				} else {
					setFilteredItems([
						{
							item: {
								name: 'No matching contacts',
								email: 'Enter email address manually to continue',
							},
						},
					]);
				}
				dispatch(setPlaceholderLoading(false));
			}
		}
	};

	React.useEffect(() => {
		clearTimeout(typingTimer.current);
		if (text) {
			typingTimer.current = setTimeout(() => {
				onTextChange(text);
			}, doneTypingInterval);
		}
	}, [text, doneTypingInterval]);

	return filteredItems.map((contact, i) => {
		return (
			<SearchItem
				selectedIndex={selectedIndex}
				key={i}
				i={i}
				searchItemMainText={contact.item.name}
				searchItemSubText={contact.item.email}
				reactIcon={<MdPermContactCalendar />}
			/>
		);
	});
};

export default EmailTypeSearch;
